"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSafeRedirectUrl = isSafeRedirectUrl;
exports.safeRedirect = safeRedirect;
// Central redirect-URL safety guard.
//
// checkout_redirect (and other redirect targets) are attacker-influenceable, so any value
// assigned to window.location.href MUST be validated here first. Validation parses the URL
// with the browser's URL parser and allowlists the protocol. Parsing (not string matching)
// is required: the parser normalizes whitespace/tabs/newlines/casing before the protocol is
// read, so tricks like "Javascript:", "java\tscript:" or leading whitespace all fail closed.

// intent: is allowed for the Android app-switch flow (opening mShop / KRA from the checkout
// redirect). It is otherwise a non-web scheme, but Chrome constrains intent: navigations and
// requires any S.browser_fallback_url to be http(s), so it cannot be used to run javascript:.
var ALLOWED_PROTOCOLS = ["https:", "http:", "intent:"];

// Returns true only for absolute/relative URLs that resolve to an http(s) or intent: target.
// Rejects javascript:, data:, vbscript:, blob:, file:, etc.
function isSafeRedirectUrl(rawUrl) {
  if (!rawUrl || typeof rawUrl !== "string") return false;
  var parsed;
  try {
    // Relative URLs resolve against the current origin; absolute URLs keep their own.
    parsed = new URL(rawUrl, window.location.origin);
  } catch (e) {
    return false;
  }
  return ALLOWED_PROTOCOLS.includes(parsed.protocol);
}

// Navigates to url only when it passes isSafeRedirectUrl. Returns whether the redirect happened.
function safeRedirect(url) {
  if (isSafeRedirectUrl(url)) {
    window.location.href = url;
    return true;
  }
  console.error("[BwA] Blocked unsafe redirect URL:", url);
  return false;
}
//# sourceMappingURL=url-safety.js.map
